import React, { useState } from "react";
import { GuardianInfo } from "../Guardian/GuardianInfo";
import { Guardian } from "../../Models/guardian.models";
import { Card } from "../card";
import { BtnType, Button } from "../Button";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { SOMETHING_WENT_WRONG } from "../../Constants/messages";
import { useUpdateStudentsGuardianInfo } from "../../hooks/students/useUpdateStudent.hooks";

interface Props {
  guardianInfo: Guardian[];
  studentId: number;
}

export const StudentGuardianInfo = ({ guardianInfo, studentId }: Props) => {
  const dispatch = useDispatch();

  const [_guardianInfo, setGuardianInfo] = useState<Guardian[]>(
    guardianInfo || []
  );

  const addGuardian = (updatedGuardianInfo: Guardian[]) => {
    setGuardianInfo(updatedGuardianInfo);
  };

  const removeGuardian = (updatedGuardianInfo: Guardian[]) => {
    setGuardianInfo(updatedGuardianInfo);
  };

  const { isLoading: isUpdatingGuardianInfo, mutate: updateGuardianInfo } =
    useUpdateStudentsGuardianInfo({
      studentId,
      onSuccess: () => {
        dispatch(setSuccessMessage("Guardian info has been updated."));
      },
      onError: (error) => {
        dispatch(
          setErrorMessage(error.response.data.message || SOMETHING_WENT_WRONG)
        );
      },
    });

  const onUpdateGuard = () => {
    updateGuardianInfo({
      guardianInfo: _guardianInfo,
    });
  };

  return (
    <Card>
      <GuardianInfo
        guardians={_guardianInfo}
        onAddGuardian={addGuardian}
        onRemoveGuardian={removeGuardian}
        onGuardianInfoChange={(updatedGuardianInfo: Guardian[]) => {
          setGuardianInfo(updatedGuardianInfo);
        }}
        totalGuardian={_guardianInfo.length || 1}
      />
      <div className="mt-12">
        <Button
          btnType={BtnType.primary}
          text="Save"
          loading={isUpdatingGuardianInfo}
          onClick={() => {
            onUpdateGuard();
          }}
        />
      </div>
    </Card>
  );
};
